export const keyArray = [
  { type: "photo", key: "photoId" },
  { type: "risc", key: "riscId" },
  { type: "site-diary", key: "siteDiaryId" },
  { type: "safety", key: "safetyId" },
  { type: "cleansing", key: "cleansingId" },
  { type: "labour", key: "labourId" },
];